import React, { forwardRef } from "react";
import cseUmich from "../static/cse_umich.jpeg";
import styles from "./Education.module.css";
import SkillWidget from "../components/SkillWidget";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

const Education = forwardRef((props, ref) => {
  const [boxRef, isVisible] = useScrollAnimation({ threshold: 0.1, once: true });
  
  return (
    <div id="education" ref={ref} className={styles.educationContainer}>
      <div className={styles.headerShowHide}>Education</div>
      <Container>
        <div 
          ref={boxRef}
          className={`${styles.educationBoxContainer} ${isVisible ? styles.animateIn : ''}`}
        >
          <Row>
            <Col sm={4}>
              <div className={styles.schoolContainer}>
                <img alt="umich" className={styles.schoolImage} src={cseUmich} />
              </div>
            </Col>
            <Col sm={8}>
              <div className={styles.descriptionContainer}>
                <div className={styles.titleStyle}>University</div>
                <p className={styles.bodyStyle}>
                  I majored in computer science at the{" "}
                  <a href="https://umich.edu/" target="_blank" rel="noreferrer">
                    University of Michigan - Ann Arbor
                  </a>{" "}
                  and I graduated from the College of Engineering in December
                  2022. Go Blue! 〽️
                </p>
                <p className={styles.bodyStyle}>Coursework: </p>
                <div className={styles.skillsContainer}>
                  <SkillWidget skill="Intro to Machine Learning" index={0} />
                  <SkillWidget skill="Computer Vision" index={1} />
                  <SkillWidget skill="Intro to Operating Systems" index={2} />
                  <SkillWidget skill="Advanced Operating Systems Special Topics" index={3} />
                  <SkillWidget skill="Intro to Computer Organization" index={4} />
                  <SkillWidget skill="User Interface Development" index={5} />
                  <SkillWidget skill="Data Structures & Algorithms" index={6} />
                  <SkillWidget skill="Applied Linear Algebra" index={7} />
                  <SkillWidget skill="Multivariable & Vector Calculus" index={8} />
                  <SkillWidget skill="Models of Social Information Processing" index={9} />
                  <SkillWidget skill="Intro to Cognitive Sciences" index={10} />
                </div>
                <p className={`${styles.bodyStyle} ${styles.funClassesText}`}>
                  Some fun classes I took:{" "}
                </p>
                <div className={styles.skillsContainer}>
                  <SkillWidget skill="Greek Mythology in Film" index={0} />
                  <SkillWidget skill="Video Game Music" index={1} />
                  <SkillWidget skill="E-Commerce Entrepreneurship" index={2} />
                </div>
                {/* <p className={styles.bodyStyle}>
            Fun fact: I was admitted to the engineering school as a chemical
            engineering major before I decided to switch to CS after an
            introductory programming course.
          </p> */}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
});

export default Education;
